// The Conversation Box relation (KV compositions) every mapped block type carries. The CMS must
// expose the field on all of them (plugin migrations + the Page Builder local setup script);
// a type without it fails the whole page query, so promote the schema before the frontend.
export const CONVERSATION_BOX = `
conversationBox {
  ... on conversationBox_Entry {
    id
    html
  }
}
`
